import Metadata from '../components/Metadata';
import { metadata, menuCard } from '../data';

export default function Cocktails() {
  return (
    <div className="bg-wine-950 text-sand-50 min-h-screen font-sans">
      <Metadata title={metadata.cocktails.title} description={metadata.cocktails.description} />

      {/* Hero Header */}
      <section className="relative py-24 border-b border-wine-900/40 bg-wine-950 text-center overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-20">
          <img
            src="https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/assets/5ea68c18-23db-4ec0-b08f-b9fe5fda53ae/cocktails-jazz.jpg"
            alt="La Fable Cocktails"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-wine-950/90 via-wine-950/70 to-wine-950" />
        </div>

        <div className="relative z-10 mx-auto max-w-3xl px-6 space-y-8">
          <h1 className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-sand-50 tracking-tighter uppercase">
            The Cocktails
          </h1>

          {/* Bartender Bio - Split Layout */}
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-center max-w-4xl mx-auto pt-4">
            {/* Image Column */}
            <div className="md:col-span-5 border border-white/10 p-2 bg-zinc-950/50 backdrop-blur-sm">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/5ea68c18-23db-4ec0-b08f-b9fe5fda53ae/william-bf3i7133-web.jpg"
                alt="William Bretlau"
                className="w-full aspect-[4/5] object-cover grayscale contrast-125"
              />
            </div>

            {/* Text Column */}
            <div className="md:col-span-7 space-y-6 text-left md:pl-4">
              <div className="space-y-2">
                <span className="font-sans text-xs tracking-[0.2em] uppercase text-sand-300 block font-normal">
                  Our Bartender
                </span>
                <h2 className="font-display text-2xl sm:text-3xl font-black text-sand-50 tracking-tighter uppercase">
                  William Bretlau
                </h2>
              </div>
              
              <p className="font-sans text-sm sm:text-base font-normal text-sand-200/80 leading-relaxed">
                Our cocktail menu is still in the making. For now, we're serving the classics you know from La Fontaine, along with a small selection of aperitivos and house favourites.
              </p>

              <p className="font-sans text-sm sm:text-base font-normal text-sand-200/80 leading-relaxed">
                The full menu is being developed by our Bar Manager at La Fontaine, William Bretlau, who is leading the cocktail programme at La Fable. Expect the classics from La Fontaine, favourite recipes shared by friends, and a few picked up on our travels.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Interactive Menu Section */}
      <section className="py-20 bg-[#f7f3eb]">
        <div className="mx-auto max-w-5xl px-6">
          <div className="text-center space-y-4 mb-12">
            <span className="font-sans text-xs tracking-[0.2em] uppercase text-zinc-600 block font-normal">
              Explore Our Selection
            </span>
            <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-black text-zinc-900 tracking-tighter uppercase">
              Cocktails & Snacks
            </h2>
            <p className="font-sans text-sm sm:text-base font-normal text-zinc-600 max-w-xl mx-auto leading-relaxed">
              Our cocktail menu is still in the making. For now, we're serving the classics you know from La Fontaine, along with a small selection of aperitivos and house favourites.
            </p>
            <div className="w-12 h-[1px] bg-zinc-300 mx-auto my-2" />
          </div>

          {/* Tab Content (Matching Wines.jsx layout) */}
          <div className="space-y-16 max-w-5xl mx-auto">
            {menuCard.snacks.map((category, idx) => (
              <div key={idx} className="space-y-6">
                <div className="flex items-center gap-4 mb-6">
                  <span className="font-display text-sm uppercase tracking-[0.25em] text-zinc-800 font-bold">
                    {category.category}
                  </span>
                  <div className="flex-1 h-[1px] bg-zinc-300/60" />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8">
                  {category.items.map((item, itemIdx) => (
                    <div key={itemIdx} className="group space-y-1">
                      <div className="flex items-baseline justify-between gap-2">
                        <span className="font-display text-base sm:text-lg text-zinc-900 font-bold tracking-tight group-hover:text-zinc-700 transition-colors">
                          {item.name}
                        </span>
                        <div className="flex-1 border-b border-dotted border-zinc-300 mx-2 self-end mb-1.5 min-w-4" />
                        <span className="font-display text-sm sm:text-base font-bold text-zinc-900 whitespace-nowrap shrink-0">
                          {item.price}
                        </span>
                      </div>
                      {item.desc && (
                        <p className="font-sans text-xs sm:text-sm font-normal text-zinc-600 leading-relaxed pt-1">
                          {item.desc}
                        </p>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Note */}
          <div className="mt-16 text-center max-w-2xl mx-auto border-t border-zinc-300/60 pt-8">
            <p className="font-sans text-xs sm:text-sm italic text-zinc-700 tracking-wide">
              For more drinks and non-alcoholic options - please ask the staff!
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
